import { Shield } from "@mui/icons-material";
import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";

interface RoleTypeChipProps {
    type: "system" | "custom";
}

const RoleTypeChip = ({ type }: RoleTypeChipProps) => {
    const [t] = useTranslation();

    return (
        <Chip
            icon={<Shield sx={{ fontSize: "14px !important", marginLeft: "6px !important" }} />}
            label={type === "system" ? t("Roles.System") : t("Roles.Custom")}
            size="small"
            sx={{
                fontSize: "12px",
                height: "24px",
                backgroundColor: "var(--backgroundZ2, #f5f5f5)",
                color: "var(--foreground, #1c1c1c)",
                "& .MuiChip-icon": {
                    color: "inherit",
                },
            }}
        />
    );
};

export default RoleTypeChip;
